import { TemplateModel, ITemplateModel } from '@common/models/TemplateModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';

export class TemplateService {
  private static baseUrl: string = '/api/template';
  static tags = {
    upsertTemplate: 'upsertTemplate',
  };

  static upsertTemplate = (data: ITemplateModel): Promise<TemplateModel> => {
    return trackPromise(
      new Promise<TemplateModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<ITemplateModel>(data)
          .then((response) => {
            resolve(new TemplateModel(response));
          })
          .catch(reject);
      }),
      this.tags.upsertTemplate,
    );
  };
}
